import { render, staticRenderFns } from "./vModal.vue?vue&type=template&id=caba74e4&scoped=true&"
import script from "./vModal.vue?vue&type=script&lang=js&"
export * from "./vModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caba74e4",
  null
  
)

/* custom blocks */
import block0 from "./vModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports